import { CoreDataSecurityMonitorsByIdName } from './name';
import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { getCoreDataSecurityMonitorsSlice } from '../get';
import { patchDataSecurityMonitorById } from '@api/data-security';
import { updateCoreDataSecurityMonitorsAllSyncSlice } from '../all/update';
import { updateCoreDataSecurityMonitorsByApplicationSyncSlice } from '../application/update';
import { updateCoreDataSecurityMonitorsSyncSlice } from '../update';

export const patchCoreDataSecurityMonitorByIdSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		preRequestActionCreators: [
			updateCoreDataSecurityMonitorsSyncSlice.syncActionCreator,
			updateCoreDataSecurityMonitorsAllSyncSlice.syncActionCreator
		],
		successActionCreators: [
			getCoreDataSecurityMonitorsSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitors
		],
		successCombinationActionCreators: [
			updateCoreDataSecurityMonitorsByApplicationSyncSlice.syncActionCreator
		]
	},
	name: CoreDataSecurityMonitorsByIdName,
	receive: false,
	request: true,
	requestHandler: patchDataSecurityMonitorById
});
